import {
  AssistantMessage,
  createChatEventExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

export const AssistantMessageEventExtension = confidenceChatPlugin.provide(
  createChatEventExtension({
    id: 'assistant-message',
    predicate: event => Boolean(event.assistantMessage) && !event.error,
    render: event => {
      const message = event.assistantMessage;
      if (!message) return null;
      return <AssistantMessage content={message.content} />;
    },
  }),
);
